import TitleHeader from "@standard/components/TitleHeader";
import DocumentTemplateForm from "./DocumentTemplateForm";
import DocumentTemplateTable from "./DocumentTemplateTable";
import { Switch, Route, useRouteMatch } from "react-router-dom";

const programType = "Master";
const programName = "Document Template";
const url = "master/documentTemplate";

export default function DocumentTemplate({ history }) {
  const { path } = useRouteMatch();

  return (
    <>
      <TitleHeader programName={programName} programType={programType} />
      <Switch>
        <Route exact path={path}>
          <DocumentTemplateTable url={url} />
        </Route>
        <Route path={`${path}/:action/:id?`}>
          <DocumentTemplateForm history={history} url={url} />
        </Route>
      </Switch>
    </>
  );
}
